module.exports = __webpack_public_path__ + "assets/add-page_icon.20bae33d.svg";